module.exports = __webpack_public_path__ + "dc6ca913f8d662c7622a4d1a91faca59.svg";